import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { addSelectedFilter, removeSelectedFilter } from 'src/app/actions';
import { getLanguage, getLanguageFromUrl, Language } from 'src/app/language';
import { Filter, FilterComparisonOperator, FilterGroupLogicaOperator, FilterKey, FilterLogicaOperator, FilterType, Material } from 'src/app/models';
import { selectedFiltersSelector } from 'src/app/selectors';

@Component({
  selector: 'image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.css']
})
export class ImageCarouselComponent implements OnInit{

  @Input('items') set _items(materiales: Material[]) {
    this.items = materiales;
  }

  items: Material[] = [];
  selectedFilterMaterial: Filter;
  showLeftControl: boolean;
  showRightControl: boolean;
  currentScrollOffset: number = 0;
  open: boolean = false;

  constructor(private store: Store) {}

  get language(): Language {
    return getLanguage(getLanguageFromUrl());
  }

  get imgsParentElement(): HTMLElement {
    return document.querySelector('.carousel-imgs');
  }

  get imgsContainerElement(): HTMLElement {
    return document.querySelector('.carousel-imgs-container');
  }

  get allImgsOffset(): number {
    const imgsElementList:NodeListOf<HTMLElement> = document.querySelectorAll('.carousel-img');
    let offset:number = 0;
    imgsElementList.forEach(node => offset += node.offsetWidth + 20)
    return offset;
  }

  get imgsContainerIsBigger(): boolean {
    return this.imgsParentElement.offsetWidth < this.allImgsOffset;
  }

  get canGoLeft(): boolean {
    return this.imgsParentElement.scrollLeft > 0;
  }

  get canGoRight(): boolean {
    return !!this.firstOverflowElementRight;
  }

  get firstOverflowElementRight(): HTMLElement | null {
    const imgsElementList:NodeListOf<HTMLElement> = document.querySelectorAll('.carousel-img');
    let offset:number = 0;
    let element: HTMLElement = null;
    const scroll: number = this.imgsContainerElement.scrollLeft;
    imgsElementList.forEach(node => {
      offset += node.offsetWidth + 20;
      if((this.imgsParentElement.offsetWidth - (offset - scroll)) < 0 && !element) element = node;
    })
    return element;
  }

  get firstOverflowElementLeft(): HTMLElement | null {
    const imgsElementList:NodeListOf<HTMLElement> = document.querySelectorAll('.carousel-img');
    let element: HTMLElement = null;
    imgsElementList.forEach((node, index) => {
      if(node.offsetLeft >= this.currentScrollOffset && !element) element = imgsElementList[index - 1];
    })
    return element;
  }

  goLeft(): void {
    if(this.canGoRight && !!this.firstOverflowElementRight){
      this.currentScrollOffset = this.firstOverflowElementLeft.offsetLeft;
      this.imgsParentElement.scrollTo(this.currentScrollOffset, 0);
    }
  }

  goRight(): void {
    if(this.canGoRight && !!this.firstOverflowElementRight){
      this.currentScrollOffset = this.imgsParentElement.scrollLeft + 20 + this.firstOverflowElementRight.offsetWidth;
      this.imgsParentElement.scrollTo(this.currentScrollOffset, 0);
    }
  }

  applyFilter(material: Material): void {
    if(this.selectedFilterMaterial){
      this.store.dispatch(removeSelectedFilter({ filter: this.selectedFilterMaterial }));
    }
    return this.store.dispatch(addSelectedFilter({ filter: {
      type: FilterType.CHECK_BOX,
      key: FilterKey.MATERIAL,
      name: material.NOMBRE,
      value: material.CODIGO,
      groupLogicalOperator: FilterGroupLogicaOperator.OR,
      logicalOperator: FilterLogicaOperator.AND,
      comparator: FilterComparisonOperator.EQUAL
    }}))
  }

  ngOnInit(): void {
    this.store.select(selectedFiltersSelector).subscribe(filters => {
      const filterMaterial: Filter = filters.find(f => f.key === FilterKey.MATERIAL);
      if(filterMaterial) this.selectedFilterMaterial = filterMaterial;
    })
  }

}
